import { TableCell, Typography } from '@mui/material';

import { tss } from 'tss-react/mui';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';
import { TimeAgo } from '@/components/date-time/TimeAgo';
import { UserAvatar } from '@/modules/user/components/UserAvatar';

const FILE_LAST_MODIFIED_CELL_FRAGMENT = graphql(`
  fragment fileLastModifiedCellFields on File {
    ...fileFields
  }
`);

interface Props {
  file: DocumentType<typeof FILE_LAST_MODIFIED_CELL_FRAGMENT>;
}

const useStyles = tss.create(({ theme }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '10em',
  },

  image: {
    marginRight: theme.spacing(1),
  },
}));

export const FileLastModifiedCell = ({ file }: Props) => {
  const { classes } = useStyles();
  const { lastModifiedBy, lastModified, lastUploadedBy, lastUploaded } = file;

  const lastModifiedDate =
    lastUploaded && (file.folder || lastUploadedBy)
      ? lastUploaded
      : lastModified;
  const lastModifiedUser =
    lastUploaded && lastUploadedBy ? lastUploadedBy : lastModifiedBy;
  const lastModifiedUserId = lastModifiedUser?._id ?? null;

  if (!(lastModifiedUserId && lastModifiedUser)) {
    return <TableCell />;
  }

  return (
    <TableCell>
      {file.folder ? (
        <Typography variant="caption" display="block">
          <TimeAgo date={lastModifiedDate} tooltip={false} />
        </Typography>
      ) : (
        <div className={classes.root}>
          <UserAvatar
            user={lastModifiedUser}
            size={20}
            className={classes.image}
          />
          <div>
            <Typography variant="caption" display="block">
              {lastModifiedUser.firstName ?? ''}{' '}
              {lastModifiedUser.lastName ?? ''}
            </Typography>
            <Typography variant="caption" display="block">
              <TimeAgo date={lastModifiedDate} tooltip={false} />
            </Typography>
          </div>
        </div>
      )}
    </TableCell>
  );
};
